var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.833 2.5c.879 0 1.599.68 1.662 1.542l.005.125v2.155c0 .393-.139.77-.39 1.07l-.098.108-4.096 4.095v4.342c0 .812-.522 1.527-1.283 1.78l-.137.039-2.083.52a1.875 1.875 0 0 1-2.325-1.69l-.005-.128v-4.863L2.99 7.502a1.664 1.664 0 0 1-.484-1.034L2.5 6.322V4.167c0-.879.68-1.599 1.542-1.662l.125-.005h11.666zm0 1.667H4.167V6.32l4.339 4.34.013.014c.02.02.038.041.056.064l-.07-.078a.84.84 0 0 1 .24.492l.002.029.002.034.001.034v5.207c0 .12.098.21.21.21l.049-.007 2.083-.521a.209.209 0 0 0 .15-.147l.008-.055V11.22l.006-.069-.006.098a.838.838 0 0 1 .175-.51l.017-.022a.838.838 0 0 1 .038-.043l.014-.014 4.34-4.34V4.168z",
    fill: "#1B3DF2",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFilter);
export default __webpack_public_path__ + "static/media/icons-filter.0657f74c31cce5be32a276a5758549d2.svg";
export { ForwardRef as ReactComponent };